import { countLeadingZeroBits1tnrq8lk0emwh as countLeadingZeroBits } from '../NumbersJs.mjs';
import { multiply2k9eolhnz1bjv as multiply } from '../js/internal/longAsBigInt/longAsBigInt.mjs';
import { coerceAtMostmgknbongtqt as coerceAtMost } from '../ranges/_Ranges.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function convertDurationUnitToMilliseconds(value, unit) {
  return multiplyNonNegativeWithoutOverflow(value, get_millisMultiplier(unit));
}
function multiplyNonNegativeWithoutOverflow(_this__u8e3s4, other) {
  var tmp;
  if (_this__u8e3s4 === 0n) {
    tmp = 0n;
  } else if (_this__u8e3s4 === 1n) {
    tmp = coerceAtMost(other, 4611686018427387903n);
  } else if (other === 1n) {
    tmp = coerceAtMost(_this__u8e3s4, 4611686018427387903n);
  } else {
    var bitSum = (128 - countLeadingZeroBits(_this__u8e3s4) | 0) - countLeadingZeroBits(other) | 0;
    tmp = bitSum < 63 ? multiply(_this__u8e3s4, other) : bitSum > 63 ? 4611686018427387903n : coerceAtMost(multiply(_this__u8e3s4, other), 4611686018427387903n);
  }
  return tmp;
}
function get_millisMultiplier(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.b2_1) {
    case 6:
      tmp = 86400000n;
      break;
    case 5:
      tmp = 3600000n;
      break;
    case 4:
      tmp = 60000n;
      break;
    case 3:
      tmp = 1000n;
      break;
    case 2:
      tmp = 1n;
      break;
    default:
      var message = 'Wrong unit for millisMultiplier: ' + _this__u8e3s4.toString();
      throw IllegalStateException().o(toString(message));
  }
  return tmp;
}
//region block: exports
export {
  convertDurationUnitToMilliseconds as convertDurationUnitToMilliseconds1tijfu5c343f5,
};
//endregion

//# sourceMappingURL=DurationUnit.mjs.map
